import { useApplicationsBannerPresenter } from './ApplicationsBanner.presenter';

export const ApplicationsBanner = () => {
  const presenter = useApplicationsBannerPresenter();

  return presenter.getApplicationsBanner() ? presenter.getApplicationsBanner() : null;
};
